import { UIBackToTop } from "@omni/ui/components/BackToTop/backToTop.style";
import { tv } from "tailwind-variants";

export const backToTop = tv({
    extend: UIBackToTop,
    variants: {
        bottomControlsVisible: {
            true: {
                base: "tw:bottom-22 tw:md:bottom-20"
            }
        }
    }
});
